<template>
    <Teleport to="body">
        <template v-if="state.visible">
            <div class="modal-backdrop fade show" />
            <div class="modal fade show d-block" tabindex="-1" @click.self="cancel">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header py-2">
                            <h6 class="modal-title">{{ state.title }}</h6>
                            <button type="button" class="btn-close" @click="cancel" />
                        </div>
                        <div class="modal-body small">{{ state.message }}</div>
                        <div class="modal-footer py-2">
                            <button class="btn btn-sm btn-secondary" @click="cancel">Cancelar</button>
                            <button class="btn btn-sm btn-danger" @click="accept">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Teleport>
</template>

<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm'

const { state, accept, cancel } = useConfirm()
</script>
